<template>
    <div>
            <vs-prompt
      :title="$t('ExportToExcel')"
      class="export-options"
      @cancel="clearFields"
      @accept="exportToExcel(data_fields)"
      :accept-text="$t('Export')"
      :cancel-text="$t('Cancel')"
      @close="clearFields"
      :active.sync="activePrompt"
    >
      <vs-input
        v-model="fileName"
        :label-placeholder="$t('FileName')"
        class="w-full"
      />
      <v-select v-model="selectedFormat" :options="formats" class="my-4" />
      <div class="flex">
        <span class="mr-4">{{ $t("CellAutoWidth") }}:</span>
        <vs-switch v-model="cellAutoWidth">{{ $t("CellAutoWidth") }}</vs-switch>
      </div>
    </vs-prompt>
    </div>
</template>

<script>
import vSelect from "vue-select";
export default {
    props:{
       title:Array,
       val:Array,
        flag:Boolean
    },
    components: {
    "v-select": vSelect,
  },
    data(){
        return{
            cellAutoWidth: true,
             fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["FirstName", "LastName", "Email", "Number", "Department"],
      headerVal: [
        "first_name",
        "last_name",
        "email",
        "contact_number",
        "department_names",
      ],
      data_fields:[],
      activePrompt: true,
        }
    },
    created()
    {
      this.data_fields={
           headerVal:this.val,
          headerTitle:this.title,
      };
       
      
      
    },
 
    methods:{
 
        exportToExcel(obj){
            import('@/assets/utils/export').then(excel => {
                const list = obj.data
                const headerVal = obj.headerval
                const headerTitle = obj.headertitle
                
                const data = this.formatJson(headerVal, list)
                excel.export_json_to_excel({
                header: headerTitle,
                data,
                filename: obj.filename,
                autoWidth: this.cellAutoWidth,
                bookType: obj.format
                })
                this.clearFields()
            })
        },
            /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then(excel => {
        const list = this.datas;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });

        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        });
        this.headerTitle = this.headerTitle1;
        this.headerVal = headerVal1;
        this.clearFields();
      });
    },
        formatJson (filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => {
                // Add col name which needs to be translated
                if (j === 'timestamp') {
                  return parseTime(v[j])
                } else {
                  return v[j]
                }

                return v[j]
            }))
            },
            clearFields () {
            this.filename = ''
            this.cellAutoWidth = true
            this.selectedFormat = 'xlsx'
            },
        }
}
</script>